// cleanup_convert_to_typescript_file_SECURITY_CONTACT
// cleanup_class_to_function_SECURITY_CONTACT
// cleanup_hoc_to_hooks_SECURITY_CONTACT

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Input } from '@glu/form-components';
import { withStyles } from '@glu/theming';

import withLocale from 'components/withLocale/withLocale';
import { styles } from 'components/securityContact/SecurityActivation.styles.js';

export class PhoneNumberComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      number: ''
    };
  }

  componentDidMount() {
    this.change({ target: this.props });
  }

  change = (event) => {
    const { format } = this.props;
    const { name = this.props.name, value: changedValue } = event.target;

    const initialValidInput = Number(changedValue);
    const number = changedValue.replace(/\D/gi, '');
    const value = number.length ? number.replace(/(\d{0,3})(\d{0,3})(\d{0,4})/i, format) : '';

    const nonNumCharDeleted = changedValue.length - value.length;
    const lengthDifference = nonNumCharDeleted >= 0 && changedValue.length >= value.length;

    if (initialValidInput || changedValue.length === 1 || lengthDifference) {
      this.setState({ number });
      return this.props.onChange({ target: { name, value }, number, value });
    }

    /** @description for when the user delete (backspace) a non number character. */
    const adjustedValue = number
      .slice(0, nonNumCharDeleted)
      .replace(/(\d{0,3})(\d{0,3})(\d{0,4})/i, format);
    const newNumber = adjustedValue.replace(/\D/g, '');
    const blankNumberValue = newNumber.length ? adjustedValue : '';

    this.setState({ number: newNumber });
    return this.props.onChange({
      target: { name, value: blankNumberValue },
      number: newNumber,
      value: blankNumberValue
    });
  };

  render() {
    const {
      classes: { groupInput },
      id,
      inputComponent: Input,
      name,
      value,
      ...rest
    } = this.props;
    return (
      <Input
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
        id={id}
        className={groupInput}
        name={name}
        onChange={this.change}
        type="text"
        value={value}
      />
    );
  }
}

PhoneNumberComponent.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  id: PropTypes.string,
  format: PropTypes.string,
  inputComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
};

PhoneNumberComponent.defaultProps = {
  id: 'phoneNumber',
  format: '($1) $2-$3',
  inputComponent: Input,
  name: 'phoneNumber',
  onChange() {},
  value: ''
};

const StyledPhoneNumberComponent = withStyles(styles)(PhoneNumberComponent);
export default withLocale(StyledPhoneNumberComponent);
